import React from "react";
import { Helmet } from "react-helmet";

function InstagramFeed({ config }) {
	return (
		<>
			<Helmet>
				<script
					src="https://apps.elfsight.com/p/platform.js"
					defer
				></script>
			</Helmet>
			<div id="instagram" className={`${config} content-visibility`} />
		</>
	);
}

export default InstagramFeed;
